import React from 'react';
import { connect } from "react-redux";
import { AppActions, IState, NewMetaItemValues, PaDocument} from '../../types/types'
import Table from '@mui/material/Table';
import TableBody from '@mui/material/TableBody';
import TableCell from '@mui/material/TableCell';
import TableContainer from '@mui/material/TableContainer';
import TableHead from '@mui/material/TableHead';
import TableRow from '@mui/material/TableRow';
import Paper from '@mui/material/Paper';
import MenuItem from '@mui/material/MenuItem';
import TextField from '@mui/material/TextField';
import Button from '@mui/material/Button';
import { revMode } from '../../types/enums';
import Checkbox from '@mui/material/Checkbox';
import { CreateCommentSheetClick, RevModeChange, setCommentSheetVisible } from '../../actions/folderViewActions';
import { ThunkDispatch } from 'redux-thunk';

interface RevisionListProps {
        documentList: PaDocument[];
        saveInProgres: boolean;
        revToUpdate: revMode;
        newMetaItemValues: NewMetaItemValues[];
        onReload: (requestId:string) => void;
        onRevModeChange: (selectedRevMode:revMode) => void;
        onSave: (fileRnos:readonly string[])=> void;
      }

const CommentList = (props:RevisionListProps) => {
  const [selected, setSelected] = React.useState<readonly string[]>([]);

  const params = new URLSearchParams(window.location.search);
  let requestIdInURL="";
  if(params.has('requestId')) requestIdInURL = params.get('requestId')!;


  const handleClick = (event: React.MouseEvent<unknown>, name: string) => {
    const selectedIndex = selected.indexOf(name);
    let newSelected: readonly string[] = [];

    if (selectedIndex === -1) {
      newSelected = newSelected.concat(selected, name);
    } else if (selectedIndex === 0) {
      newSelected = newSelected.concat(selected.slice(1));
    } else if (selectedIndex === selected.length - 1) {
      newSelected = newSelected.concat(selected.slice(0, -1));
    } else if (selectedIndex > 0) {
      newSelected = newSelected.concat(
        selected.slice(0, selectedIndex),
        selected.slice(selectedIndex + 1),
      );
    }

    setSelected(newSelected);
  };

  const isSelected = (name: string) => selected.indexOf(name) !== -1;

  return <div>
             <TableContainer component={Paper}>
                <Table size="small" padding="none">
                  <TableRow>
                    <TableCell className="HeaderStatusDrop">
                      <TextField select 
                          id="revMode"
                          variant="standard"
                          value={props.revToUpdate}
                          className="HeaderStatusDrop"
                          size="small"
                          label="Rev mode"
                          onChange={(event)=>props.onRevModeChange(event.target.value as any as revMode)}
                          disabled={props.saveInProgres}
                      >
                        <MenuItem value={revMode.LATEST_REV}>Latest revision</MenuItem>
                        <MenuItem value={revMode.CURRENT_REV}>Current revision</MenuItem>
                      </TextField>
                    </TableCell>
                    <TableCell className="AlignBottom">
                    </TableCell>
                    <TableCell>
                    </TableCell>
                  </TableRow>
                  <TableRow>
                        <TableCell className="HeaderStatusDrop">  
                        </TableCell>
                        <TableCell>
                        </TableCell>
                        <TableCell width="420" className="AlignBottom">
                            <Button className="MuiButtonMargin" size="small" variant="contained" disabled={props.saveInProgres} onClick={()=>props.onReload(requestIdInURL)}>Reload list</Button>
                            <Button className="MuiButtonMargin" size="small" variant="contained" onClick={()=>props.onSave(selected)}
                              disabled={props.saveInProgres}
                              >Create comment sheet</Button>
                          </TableCell>
                  </TableRow>
                <TableRow className="EmptyRow">
                  <TableCell></TableCell>
                  <TableCell></TableCell>
                  <TableCell></TableCell>
                  </TableRow>
                </Table>

                  <Table size="small" padding="none" id="FilesList" className="DocumentList">
                        <TableHead>
                          <TableRow className="MuiTblHeaderRow">
                            <TableCell className="resultCell"></TableCell>
                            <TableCell width="10"></TableCell>
                            <TableCell width="10"></TableCell>
                            <TableCell>Filename</TableCell>
                            <TableCell></TableCell>                                                        
                          </TableRow>
                        </TableHead>
                        <TableBody>
                    {props.documentList
                        .sort((a,b) => a.DocId>b.DocId ? 1 : -1)
                        .map(row => {
                            return <>
                              <TableRow>
                                <TableCell colSpan={5}>Document: {row.DocId} - {row.RevisionToUpdate.RevisionCode} - {row.RevisionToUpdate.Status}</TableCell>
                              </TableRow> 
                                          {row.RevisionToUpdate.Files
                                          .filter(x=> x.Extension.toUpperCase() === "PDF")
                                          .sort((a,b) => a.FileRno>b.FileRno ? 1 : -1)
                                          .map( file => {
                                            const isItemSelected = isSelected(file.FileRno.toString());
                                            return <TableRow  key={file.FileRno.toString()}
                                                            role="checkbox">
                                                      <TableCell className="resultCell">
                                                        {props.newMetaItemValues.filter(x=>
                                                                x.DocumentID === file.FileRno.toString()
                                                                && x.SaveResult !== undefined && x.SaveResult !== "" 
                                                          ).length > 0
                                                          ? props.newMetaItemValues.filter(x=>
                                                              x.DocumentID === file.FileRno.toString()
                                                              && x.SaveResult !== undefined && x.SaveResult !== "" 
                                                            )[0].SaveResult 
                                                          : ""
                                                        }
                                                      </TableCell>
                                                        <TableCell width="10"><Checkbox
                                                          color="primary"
                                                          disabled={props.saveInProgres}
                                                          checked={isItemSelected}
                                                          onClick={(event) => handleClick(event, file.FileRno.toString())}
                                                        />
                                                      </TableCell>
                                                      <TableCell width="10"></TableCell>
                                                      <TableCell>{file.Name} {file.Comment==="" ? "" : ` (${file.Comment})`}</TableCell>
                                                      <TableCell>
                                                          <Button className="MuiButtonMargin" size="small" variant="contained" onClick={()=>props.onSave([file.FileRno.toString()])}
                                                                disabled={props.saveInProgres}
                                                                >Create comment sheet</Button>
                                                      </TableCell>
                                                  </TableRow>
                                          })}
                            </>

                        })
                      }
                    </TableBody>
                  </Table>
                
              </TableContainer>
      </div>
      
}

const mapStateToPropsCommentList = (state:IState) => { 
  return {
   saveInProgres:state.uiState.SAVE_REVISIONS_IsLoading,
   documentList: state.uiItems.documentList,
   newMetaItemValues: state.uiItems.newMetaItemValues,
   revToUpdate: state.uiItems.revToUpdate,
}}

const mapDispatchToPropsCommentList = (dispatch:ThunkDispatch<IState,undefined,AppActions>)  => ( {
  onReload: (requestId:string) => dispatch(setCommentSheetVisible(requestId)),
  onSave: (fileRnos:readonly string[]) => dispatch(CreateCommentSheetClick(fileRnos)),
  onRevModeChange: (value: revMode) => dispatch(RevModeChange(value)),
})

export default connect(mapStateToPropsCommentList,mapDispatchToPropsCommentList)(CommentList)
  